import React from 'react';

import { ArgumentHomeyScript } from './argument-homeyscript/ArgumentHomeyScript';
import { ArgumentHomeyScriptWithArgument } from './argument-homeyscript/ArgumentHomeyScriptWithArgument';
import { ArgumentText } from './argument-text/ArgumentText';
import { ArgumentAutocomplete } from './ArgumentAutocomplete';
import { ArgumentCheckbox } from './ArgumentCheckbox';
import { ArgumentColor } from './ArgumentColor';
import { ArgumentDate } from './ArgumentDate';
import { ArgumentDevice } from './ArgumentDevice';
import { ArgumentDropdown } from './ArgumentDropdown';
import { ArgumentMultiselect } from './ArgumentMultiselect';
import { ArgumentNumber } from './ArgumentNumber';
import { ArgumentRange } from './ArgumentRange';
import { ArgumentTime } from './ArgumentTime';

export function FlowArgument(props) {
  if (props.argument == null) {
    console.error('Expected card argument');
    return null;
  }

  const Component = getComponent(props);

  return (
    // No component is created here these are all references.
    // eslint-disable-next-line react-hooks/static-components
    <Component
      cardContainerRef={props.cardContainerRef}
      argumentKey={props.argumentKey}
      argumentTypeText={props.argumentTypeText}
      cardType={props.cardType}
      cardIndex={props.cardIndex}
      argument={props.argument}
      otherArguments={props.otherArguments}
      card={props.card}
      data={props.data}
      isFirstArgument={props.isFirstArgument}
      isDisabled={props.isDisabled}
      isDisabledStyle={props.isDisabledStyle}
      onUpdate={props.onUpdate}
      onPropertyUpdate={props.onPropertyUpdate}
    />
  );
}

function getComponent(props) {
  switch (props.argument.type) {
    case 'code':
      if (props.argument.language === 'homeyscript') {
        if (props.otherArguments.argument != null) {
          return ArgumentHomeyScriptWithArgument;
        }

        return ArgumentHomeyScript;
      }

      return ArgumentText;
    case 'text':
      return ArgumentText;
    case 'autocomplete':
      return ArgumentAutocomplete;
    case 'dropdown':
      return ArgumentDropdown;
    case 'multiselect':
      return ArgumentMultiselect;
    case 'range':
      return ArgumentRange;
    case 'number':
      return ArgumentNumber;
    case 'color':
      return ArgumentColor;
    case 'date':
      return ArgumentDate;
    case 'time':
      return ArgumentTime;
    case 'checkbox':
      return ArgumentCheckbox;
    case 'device':
      return ArgumentDevice;
    default:
      console.error(`unknown argument type ${props.argument.type}`);
      return ArgumentText;
  }
}
